// Types
import { Colors } from '../../../styles/theme/types';
import { variant } from './types';

/**
 * Color de letra de cada etiqueta según su fondo (feedback del usuario
 * 2026-10-26, accesibilidad): sobre los fondos claros la letra blanca no se
 * leía (1,4-2,8:1). Va en un tono oscuro de la MISMA familia que el fondo —no en
 * negro, que despegaba del resto— con ≥4,5:1 (WCAG AA). Las que no salen aquí
 * tienen fondo oscuro y siguen en blanco. La usan la etiqueta y la flechita de
 * su menú, para que nunca vayan de distinto color.
 */
const TEXT_BY_VARIANT: Partial<Record<variant, keyof Colors>> = {
  [variant.Paused]: 'tagTextGold',
  [variant.Partial]: 'tagTextGold',
  [variant.PendingWork]: 'tagTextGold',
  [variant.Open]: 'tagTextBlue',
  [variant.WorkInProgress]: 'tagTextBlueSoft',
  [variant.Validated]: 'tagTextGreen',
  [variant.Managed]: 'tagTextOrange',
  [variant.UnlinkedWork]: 'tagTextOrange',
  [variant.PendingLink]: 'tagTextOrange',
  [variant.Campaign]: 'tagTextPink',
  [variant.SurveillanceRoute]: 'tagTextPink',
};

export const tagTextColor = (v: variant): keyof Colors =>
  TEXT_BY_VARIANT[v] ?? 'white';
